import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { makeStyles } from "@mui/styles/";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import StoreText from "../store/StoreText";
import PriceTag from "../../assets/price-tag.png";
const useStyles = makeStyles({
  offerCard: {
    borderStyle: "solid",
    opacity: 1,
    borderWidth: 0.35,
    borderRadius: 10,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#fafafa",
    paddingLeft: 5,
    paddingRight: 5,
    paddingBottom: 5,
    paddingTop: 5,
    marginTop: 5,
    marginBottom: 5,
  },
  counterValue: {
    fontSize: 16,
    fontWeight: "500",
    left: 15,
  },
  centerElement: { justifyContent: "center", alignItems: "center" },
  info: {
    display: "flex",
    flexDirection: "column",
  },
  cardImage: {
    width: 150,
    height: 150,
    borderRadius: 25,
  },
  details: {
    marginTop: 2,
    marginBottom: 2,
  },
  discountExpText: {
    textAlign: "center",
    color: "gray",
    fontWeight: "400",
    fontSize: 13,
  },
});

const OfferCard = ({ offer }) => {
  const { t, i18n } = useTranslation();
  const expiry = offer.expireAt.toDate() ?? undefined;
  const diff = !!expiry ? moment().diff(expiry, "days") * -1 : "";
  const navigate = useHistory();
  const styles = useStyles();
  const theme = useTheme();
  const handlePress = () => {
    if (!!offer?.link) {
      window.open(offer?.link);
    } else {
      navigate.push("/offer-details/" + offer?.id);
    }
  };
  return (
    <Grid item key={!!offer?.id ? offer?.id : "all  card"} xs={12} sm={12} md={4}>
      <div
        className={styles.offerCard}
        style={{ cursor: "pointer", borderColor: theme.light.primary }}
        onClick={handlePress}
      >
        {offer && !!offer.image && offer.image != "" ? (
          <img className={styles?.cardImage} src={offer.image} />
        ) : (
          <img className={styles?.cardImage} src={PriceTag} />
        )}
        <div className={styles?.info} style={{ marginTop: 10 }}>
          <Typography style={{ color: "black" }}>
            {i18n.language == "ar" ? offer.titleAr : offer.titleEn}
          </Typography>
        </div>
        <div className={styles?.info} style={{ flexDirection: "row" }}>
          <div
            style={{
              marginTop: 4,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginRight: 10,
            }}
          >
            {!!offer.storeInfo && (
              <StoreText
                className={styles.details}
                image={offer?.storeInfo?.image}
                storeID={offer?.storeId}
                text={
                  offer.storeInfo[
                    i18n.language == "ar" ? "nameAr" : "nameEn"
                  ] ?? ""
                }
              />
            )}
          </div>
          {!!expiry && (
            <Typography
              className={styles.discountExpText}
              style={{ textAlign: "center", alignSelf: "center" }}
            >
              {t("product.expire").replace("{days}", diff)}{" "}
            </Typography>
          )}
        </div>
      </div>
    </Grid>
  );
};

export default OfferCard;
